import { useParams } from "react-router-dom"
import { useState, useEffect, Fragment } from 'react'
import { Box, Card, Checkbox, Container, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, TextField, Typography } from "@mui/material"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material"
import Loading from "../../../../load/loading";
import api from "../../../../services/api";
import DateView from "../../../../utils/date";
import HeaderSession from "../../../../utils/headerSession";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import Email from "../../../../utils/email";

const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.breakpoints.up("md")]: {
            // width: '100%',
            height: "100%",
            position: "sticky",
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    },
}));

export default function GestFarmacovigilancia({ element: component, ...rest }) {
    const classes = useStyles();
    let { id } = useParams()
    const [notificacao, setNotificacao] = useState('')
    // const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)
    const handleChange = () => { };

    const getChecked = (key) => {
        const v = notificacao?.efeitosIndesejados?.evolucaoEfeitos?.[key];
        if (typeof v === 'boolean') return v;
        if (typeof v === 'string') return v.toLowerCase() === 'true' || v === '1';
        if (typeof v === 'number') return v === 1;
        return false;
    };

    // Estado do modal de apresentação
    const [openApresentacao, setOpenApresentacao] = useState(false);
    const [apresentacaoData, setApresentacaoData] = useState(null);

    const opcoesApresentacao = [
        { key: 'a', label: 'Comprimidos/cápsulas orais' },
        { key: 'b', label: 'Suspensão, xaropes' },
        { key: 'c', label: 'Injecção' },
        { key: 'd', label: 'Diluente' },
        { key: 'e', label: 'Pó para reconstituição da suspensão' },
        { key: 'f', label: 'Pó para reconstituição de injectáveis' },
        { key: 'g', label: 'Gotas oftálmicas' },
        { key: 'h', label: 'Gotas nasais' },
        { key: 'i', label: 'Gotas auriculares' },
        { key: 'j', label: 'Nebulizadores' },
        { key: 'k', label: 'Cremes, pomadas, pastas, linimentos' },
    ];

    const abrirModalApresentacao = (item) => {
        // Preferir novo payload: item.apresentacaoProducto
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null;

        // Fallback: formato antigo com campos identificacaoProductoApresentacaoProductoA..K e ...Outros
        if (!data) {
            const d = {};
            ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'].forEach(L => {
                d[L.toLowerCase()] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true;
            });
            const outrosAntigo = item?.identificacaoProductoApresentacaoProductoOutros;
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || '';
                data = d;
            }
        }

        setApresentacaoData(data || {});
        setOpenApresentacao(true);
    };

    // Opções de defeitos (usadas para listas na visualização)
    const opcoesDefeitos = [
        { key: 'a', label: 'Separação' },
        { key: 'b', label: 'Solidificação' },
        { key: 'c', label: 'Esfarelamento' },
        { key: 'd', label: 'Moldura defeituasa' },
        { key: 'e', label: 'Mudança de Cheiro' },
        { key: 'f', label: 'Mudança de cor' },
        { key: 'g', label: 'Rotulagem defeituosa' },
        { key: 'h', label: 'Acondicionamento defeituoso' },
        { key: 'i', label: 'Rotulagem e prospecto deficiente' },
    ];

    // (Removidos helpers de lista baseados em <ul>; agora usamos checkboxes desabilitados)

    // Helpers para obter os dados brutos e facilitar a renderização de checkboxes
    const getApresentacaoDataRaw = (item) => {
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null;
        if (!data) {
            const d = {};
            ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'].forEach((key, idx) => {
                const L = String.fromCharCode(65 + idx);
                d[key] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true;
            });
            const outrosAntigo = item?.identificacaoProductoApresentacaoProductoOutros;
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || '';
                data = d;
            }
        }
        return data || {};
    };

    const getDefeitosDataRaw = (item) => {
        const data = item?.defeitos && typeof item.defeitos === 'object' ? item.defeitos : {};
        return data || {};
    };

    // Monta respostas para o card "Condições de armazenamento" (read-only)
    const getArmazenamentoRespostas = () => {
        const ca = notificacao?.conducoesArmazenamento || {};
        // Mapeamento: a..e -> perguntas Sim/Não; f -> detalhes/outros (e fallback se vier em outro campo)
        const pickResp = (k) => (ca?.[k]?.resposta || '').toString();
        // Escolhe o primeiro outrosDetalhes preenchido em a..f como fallback
        const outrosDetalhes = (
            ca?.f?.outrosDetalhes ||
            ca?.a?.outrosDetalhes ||
            ca?.b?.outrosDetalhes ||
            ca?.c?.outrosDetalhes ||
            ca?.d?.outrosDetalhes ||
            ca?.e?.outrosDetalhes ||
            ''
        );
        return {
            requerRefrigeracao: pickResp('a'),
            jaFoiUsado: pickResp('b'),
            foiDevolvido: pickResp('c'),
            defeitoDetectado: pickResp('d'),
            armazenadoCorretamente: pickResp('e'),
            conducoesArmazenamentoOutrosDetalhes: outrosDetalhes,
        };
    };

    // Helper para formatar datas de manifestação (evita problemas do componente <Date /> aqui)
    const formatarDataManifestacao = (valor, incluirHora = false) => {
        if (!valor) return '';
        const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
        const d = new Date(valor);
        if (Number.isNaN(d.getTime())) return '';
        const dia = d.getDate();
        const mes = meses[d.getMonth()];
        const ano = d.getFullYear();
        if (incluirHora) {
            const hora = d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
            return ` ${dia} de ${mes} as ${hora}h de ${ano}`;
        }
        return `dia ${dia} ${mes} ${ano}`;
    };

    useEffect(() => {
        api.get(`/farmaco-vigilancia/${id}`)
            .then(response => {
                console.log(response)
                setNotificacao(response.data.farmacoVigilancia);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])

    return (
        notificacao
            ?
            <Container>
                <HeaderSession title={'GESTÃO DE NOTIFICAÇÃO'} />

                <Grid container>
                    <Grid item className={classes.grid1}>
                        <NavLateral
                            observacoesFeitas={notificacao?.observacoes}
                            notificacao={notificacao}
                            setUpdate={setUpdate}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>
                        {/* {React.cloneElement(component, {
                                notificacao: notificacao,
                            })} */}

                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <Typography variant="body1" lineHeight={1.5}> <strong>  Número de notificação:</strong> {notificacao?.numero}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>  Data de entrada: </strong> <DateView date={notificacao?.createdAt} /> </Typography>
                            {notificacao?.dataDespacho &&
                                <Typography variant="body1" lineHeight={1.5}> <strong>  Data de despacho: </strong> <DateView date={notificacao?.dataDespacho} /> </Typography>
                            }
                            <Typography variant="body1" lineHeight={1.5}> <strong>  Tipo de notificação:</strong> {notificacao?.tipo}</Typography>
                        </Card>


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <HeaderGestorConfigs title='Entidade Sanitária' />

                            <Typography variant="body1" lineHeight={1.5}> <strong>Unidade sanitária/Farmácia:</strong> {notificacao?.unidadeSanitaria?.nome}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Serviço:</strong> {notificacao?.unidadeSanitaria?.servico}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Província:</strong> {notificacao?.unidadeSanitaria?.provincia}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Municipio:</strong> {notificacao?.unidadeSanitaria?.municipio}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Bairro:</strong> {notificacao?.unidadeSanitaria?.bairro}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Rua:</strong> {notificacao?.unidadeSanitaria?.rua}</Typography>
                            <Typography variant="body1" lineHeight={1.5}><Email email={notificacao?.unidadeSanitaria?.email} /></Typography>
                        </Card>






                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Condições de armazenamento' />
                                {(() => {
                                    const Respostas = getArmazenamentoRespostas();
                                    return (
                                        <Grid container spacing={2} style={{ margin: '0 10px' }}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O Produto  requer refrigeração?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="requerRefrigeracao" checked={Respostas.requerRefrigeracao === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="requerRefrigeracao" checked={Respostas.requerRefrigeracao === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O produto já foi usado na unidade sanitária?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="jaFoiUsado" checked={Respostas.jaFoiUsado === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="jaFoiUsado" checked={Respostas.jaFoiUsado === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O produto foi entregue e devolvido pelo cliente/paciente?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="foiDevolvido" checked={Respostas.foiDevolvido === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="foiDevolvido" checked={Respostas.foiDevolvido === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O defeito foi detectado pela unidade sanitária?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="defeitoDetectado" checked={Respostas.defeitoDetectado === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="defeitoDetectado" checked={Respostas.defeitoDetectado === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O Produto está armazenado de acordo com as Boas Práticas de Armazenamento?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="armazenadoCorretamente" checked={Respostas.armazenadoCorretamente === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="armazenadoCorretamente" checked={Respostas.armazenadoCorretamente === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid display="flex" flexDirection="column" container spacing={1} marginRight={3} marginTop={4}>
                                                <FormLabel>Outros detalhes:</FormLabel>

                                                <TextField
                                                    // label=""
                                                    name="conducoesArmazenamentoOutrosDetalhes"
                                                    multiline
                                                    variant="filled"
                                                    // fullWidth
                                                    // size="small"
                                                    value={Respostas.conducoesArmazenamentoOutrosDetalhes || ''}
                                                    InputProps={{ readOnly: true }}
                                                    sx={{ mt: 1, pointerEvents: 'none' }}
                                                />
                                            </Grid>
                                        </Grid>
                                    );
                                })()}
                            </Card>
                        )}

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Paciente' />
                                <Typography variant="body1" lineHeight={1.5}> <strong>Nome:</strong> {notificacao?.paciente?.nome}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Telefone:</strong> {notificacao?.paciente?.telefone}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Email:</strong> {notificacao?.paciente?.email}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Idade:</strong> {notificacao?.paciente?.idade}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Sexo:</strong> {notificacao?.paciente?.sexo === "M" ? "Masculino" : notificacao?.paciente?.sexo === "F" ? "Femenino" : ''}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Provincia:</strong> {notificacao?.paciente?.provincia}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Municipio:</strong> {notificacao?.paciente?.municipio}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Bairro:</strong> {notificacao?.paciente?.bairro}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Peso:</strong> {notificacao?.paciente?.peso}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Altura:</strong> {notificacao?.paciente?.altura}</Typography>
                                <Typography variant="body1" lineHeight={1.5}> <strong>Raça:</strong> {notificacao?.paciente?.raca}</Typography>
                                <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.gestante} onChange={handleChange} name="medicosSP" />} label="Gestante" />
                                <Box marginTop={2}>
                                    <HeaderGestorConfigs title='Paciente / Antecedentes' />

                                    <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.medicosSP} onChange={handleChange} name="medicosSP" />} label="Médicos, Serológicos, Psiquiátrico" />
                                    <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.cirurgicos} onChange={handleChange} name="cirurgicos" />} label="Cirúrgicos" />
                                    <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.abusoDependencia} onChange={handleChange} name="abusoDependencia" />} label="De Abuso ou Dependência" />
                                    <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.alergiasConhecidas} onChange={handleChange} name="alergiasConhecidas" />} label="Alergias conhecidas" />
                                </Box>

                            </Card>
                        )}

                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' ? (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Identificação do produto' />
                                <TableContainer component={Paper} style={{ marginTop: 8 }}>
                                    <Table size="small" stickyHeader aria-label="tabela de identificação do produto">
                                        <TableHead>
                                            <TableRow>
                                                {/* <TableCell align="center">N.º</TableCell> */}
                                                <TableCell align="center"><Typography noWrap>Nome comercial / DCI</Typography> </TableCell>
                                                <TableCell align="center"><Typography noWrap>Número do lote</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de fabrico</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de expiração</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de recepção</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Fabricante</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Fornecedor</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                <Fragment key={index}>
                                                    <TableRow hover>
                                                        {/* <TableCell align="center">{index + 1}</TableCell> */}
                                                        <TableCell align="center">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</TableCell>
                                                        <TableCell align="center">{item?.numeroLote || ''}</TableCell>
                                                        <TableCell align="center">{item?.dataFabrico ? <DateView date={item?.dataFabrico} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.dataRecepcao ? <DateView date={item?.dataRecepcao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.nomeFabricante || ''}</TableCell>
                                                        <TableCell align="center">{item?.nomeFornecedor || ''}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan={7} style={{ background: '#fafafa', padding: 12 }}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography variant="subtitle2" sx={{ color: '#85287E', fontWeight: 600 }}>Apresentação do produto</Typography>
                                                                    {(() => {
                                                                        const data = getApresentacaoDataRaw(item);
                                                                        const temAlgum = opcoesApresentacao.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros);
                                                                        return temAlgum ? (
                                                                            <Grid container spacing={0} sx={{ mt: 0.2 }}>
                                                                                {opcoesApresentacao.map(opt => (
                                                                                    <Grid item xs={12} key={opt.key}>
                                                                                        <FormControlLabel
                                                                                            onClick={(e) => e.preventDefault()}
                                                                                            sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={Boolean(data?.[opt.key])}
                                                                                                    tabIndex={-1}
                                                                                                    disableRipple
                                                                                                    onClick={(e) => e.preventDefault()}
                                                                                                    sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                                                                    inputProps={{ tabIndex: -1, 'aria-disabled': true }}
                                                                                                />
                                                                                            }
                                                                                            label={opt.label}
                                                                                        />
                                                                                    </Grid>
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <Grid item xs={12}>
                                                                                        <FormLabel component="legend">Outros</FormLabel>
                                                                                        <TextField value={data?.outros || ''} fullWidth InputProps={{ readOnly: true }} size="small" sx={{ mt: 0.5 }} />
                                                                                    </Grid>
                                                                                ) : null}
                                                                            </Grid>
                                                                        ) : (
                                                                            <Typography variant="body2" color="text.secondary">Sem informação</Typography>
                                                                        );
                                                                    })()}
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography variant="subtitle2" sx={{ color: '#85287E', fontWeight: 600 }}>Defeitos</Typography>
                                                                    {(() => {
                                                                        const data = getDefeitosDataRaw(item);
                                                                        const temAlgum = opcoesDefeitos.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros);
                                                                        return temAlgum ? (
                                                                            <Grid container spacing={0} sx={{ mt: 0.2 }}>
                                                                                {opcoesDefeitos.map(opt => (
                                                                                    <Grid item xs={12} key={opt.key}>
                                                                                        <FormControlLabel
                                                                                            onClick={(e) => e.preventDefault()}
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={Boolean(data?.[opt.key])}
                                                                                                    tabIndex={-1}
                                                                                                    disableRipple
                                                                                                    onClick={(e) => e.preventDefault()}
                                                                                                />
                                                                                            }
                                                                                            label={opt.label}
                                                                                        />
                                                                                    </Grid>
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <Grid item xs={12}>
                                                                                        <FormLabel component="legend">Outros</FormLabel>
                                                                                        <TextField value={data?.outros || ''} fullWidth InputProps={{ readOnly: true }} size="small" sx={{ mt: 0.5 }} />
                                                                                    </Grid>
                                                                                ) : null}
                                                                            </Grid>
                                                                        ) : (
                                                                            <Typography variant="body2" color="text.secondary">Sem informação</Typography>
                                                                        );
                                                                    })()}
                                                                </Grid>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                </Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        ) : (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Medicamentos' />
                                <div >
                                    <TableContainer component={Paper} style={{ marginTop: 8 }}>
                                        <Table size="small" stickyHeader aria-label="tabela de medicamentos">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center"><Typography noWrap>N.º</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Nome comercial / DCI</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Apresentação</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Dose diária</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Via e local de administração</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Motivo do tratamento</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Número do lote</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Data de caducidade</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Local de compra</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Início do tratamento</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Término do tratamento</Typography></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                    <TableRow key={index} hover>
                                                        <TableCell align="center">{index + 1}</TableCell>
                                                        <TableCell align="center">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</TableCell>
                                                        <TableCell align="center">
                                                            <Button variant="text" onClick={() => abrirModalApresentacao(item)}>
                                                                Ver apresentação
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell align="center">{item?.doseDiaria || ''}</TableCell>
                                                        <TableCell align="center">{item?.viaLocalAdmin || ''}</TableCell>
                                                        <TableCell align="center">{item?.motivoTratamento || ''}</TableCell>
                                                        <TableCell align="center">{item?.numeroLote || ''}</TableCell>
                                                        <TableCell align="center">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.localCompra || ''}</TableCell>
                                                        <TableCell align="center">{item?.InicioDataToma ? <DateView date={item?.InicioDataToma} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.terminoDataToma ? <DateView date={item?.terminoDataToma} /> : ''}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Card style={{ padding: 20, marginTop: 10, }}>
                                        <HeaderGestorConfigs title='Outras Indicações' />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.automedicacao} onChange={handleChange} name="automedicacao" />} label="Automedicação" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.farmacodependencia} onChange={handleChange} name="farmacodependencia" />} label="Farmacodependência" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.erroTerapeutico} onChange={handleChange} name="erroTerapeutico" />} label="Erro Terapêutico" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.campanhaVacinacao} onChange={handleChange} name="campanhaVacinacao" />} label="Campanha Vacinação" />
                                    </Card>
                                </div>
                            </Card>
                        )}

                        <Dialog open={openApresentacao} onClose={() => setOpenApresentacao(false)} maxWidth="md" fullWidth>
                            <DialogTitle>Apresentação do produto</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {opcoesApresentacao.map(opt => (
                                        <Grid item xs={12} sm={6} md={4} key={opt.key}>
                                            <div
                                                style={{
                                                    background: apresentacaoData?.[opt.key] ? '#85287E' : '#f6f2fc',
                                                    borderRadius: 8,
                                                    padding: 12,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    transition: 'background 0.2s',
                                                    color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E',
                                                }}
                                            >
                                                <FormControlLabel
                                                    onClick={(e) => e.preventDefault()}
                                                    sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(apresentacaoData?.[opt.key])}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            onClick={(e) => e.preventDefault()}
                                                            sx={{
                                                                pointerEvents: 'none',
                                                                cursor: 'default',
                                                                color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E',
                                                                '&.Mui-checked': { color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E' },
                                                            }}
                                                            inputProps={{ tabIndex: -1, 'aria-disabled': true }}
                                                        />
                                                    }
                                                    label={<span style={{ fontWeight: 500, color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E' }}>{opt.label}</span>}
                                                />
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                                {apresentacaoData?.outros ? (
                                    <Box mt={3}>
                                        <FormLabel component="legend" style={{ pointerEvents: 'none', color: '#85287E', fontWeight: 600 }}>Outros</FormLabel>
                                        <TextField value={apresentacaoData?.outros || ''} fullWidth InputProps={{ readOnly: true }} style={{ marginTop: 8 }} />
                                    </Box>
                                ) : null}
                            </DialogContent>
                            <DialogActions>
                                <Button color="secondary" onClick={() => setOpenApresentacao(false)}>Fechar</Button>
                            </DialogActions>
                        </Dialog>

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Efeitos Indesejáveis' />

                                <FormControl component="fieldset">

                                    <FormGroup>
                                        <FormLabel marginTop={2} component="legend">Breve Descição de Efeito Indesejavel</FormLabel>
                                        <Box marginTop={2}>
                                            <TextField
                                                marginTop={2}
                                                // label="Breve descrição"
                                                variant="filled"
                                                value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                                multiline
                                                rows={4}
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                                sx={{ pointerEvents: 'none' }}
                                            />
                                        </Box>
                                        {(notificacao?.efeitosIndesejados?.inicioManifestacao || notificacao?.efeitosIndesejados?.fimManifestacao) ? (
                                            <Typography variant="body1" lineHeight={1.5} marginTop={4}>
                                                {`Prazo de manifestação: ${formatarDataManifestacao(notificacao?.efeitosIndesejados?.inicioManifestacao, true)}${(notificacao?.efeitosIndesejados?.inicioManifestacao && notificacao?.efeitosIndesejados?.fimManifestacao) ? ' à ' : ''}${formatarDataManifestacao(notificacao?.efeitosIndesejados?.fimManifestacao, false)}`}
                                            </Typography>
                                        ) : null}
                                    </FormGroup>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', gap: '2rem' }}>
                                        <FormGroup>
                                            <FormLabel component="legend">Evolução dos Efeitos indesejaveis</FormLabel>
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.riscoVida} onChange={handleChange} name="riscoVida" />} label="Risco de vida" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.motivouHospitalizacao} onChange={handleChange} name="motivouHospitalizacao" />} label="Motivou hospitalização" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.prolongouHospitalizacao} onChange={handleChange} name="prolongouHospitalizacao" />} label="Prolongou hospitalização" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.malformacaoCongenita} onChange={handleChange} name="malformacaoCongenita" />} label="Malformação Congênita" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.naoRecuperouAind} onChange={handleChange} name="naoRecuperouAind" />} label="Não recuperou ainda" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouSemSequelas} onChange={handleChange} name="recuperouSemSequelas" />} label="Recuperou sem sequelas" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouComSequelas} onChange={handleChange} name="recuperouComSequelas" />} label="Recuperou com sequelas" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.desconhecido} onChange={handleChange} name="desconhecido" />} label="Desconhecido" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.morte} onChange={handleChange} name="morte" />} label="Morte" />
                                            <FormControlLabel control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.suspendeuMedicamento} onChange={handleChange} name="suspendeuMedicamento" />} label="Suspendeu o Medicamento" />
                                            <FormControlLabel control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.diminuiuDoseMedicamento} onChange={handleChange} name="diminuiuDoseMedicamento" />} label="Diminuiu a dose do Medicamento" />
                                            <Typography variant="body1" lineHeight={1.5}> Efeito desapareceu após suspensão?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM}</Typography>
                                            <Typography variant="body1" lineHeight={1.5}> Efeito reapareceu após reintrodução?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM}</Typography>
                                        </FormGroup>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '8px' }}>

                                            <FormGroup>
                                                <FormLabel marginTop={2} component="legend">Tratamento Corrector</FormLabel>
                                                <Box marginTop={2}>
                                                    <TextField
                                                        marginTop={2}
                                                        // label="Breve descrição"
                                                        variant="filled"
                                                        value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                                        multiline
                                                        rows={4}
                                                        fullWidth
                                                        InputProps={{ readOnly: true }}
                                                        sx={{ pointerEvents: 'none' }}
                                                    />
                                                </Box>
                                            </FormGroup>
                                        </div>
                                    </div>
                                </FormControl>
                            </Card>
                        )}


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <HeaderGestorConfigs title='Notificador' />
                            <Typography variant="body1" lineHeight={1.5}> <strong>Nome:</strong> {notificacao?.notificador?.nome}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Categoría Profissional:</strong> {notificacao?.notificador?.categoriaProfissional}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Telefone:</strong> {notificacao?.notificador?.tel}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Email:</strong> {notificacao?.notificador?.email}</Typography>
                        </Card>

                        {/* <CreateObservacaoNotificacao
                            userId={user?._id}
                            notificacaoId={id}
                            observacoes={notificacao?.observacoes}
                            setUpdate={setUpdate}
                        /> */}

                        {/* <ResponseNotificacao
                            userId={user?._id}
                            notificacao={notificacao}
                            setUpdate={setUpdate}
                        /> */}
                    </Grid>
                </Grid>

            </Container>
            :
            <Loading text={'A carregar notificacao.'} />
    )
}